import React from "react";
import axios from "axios";
import Layout from "../../components/layout";
import HeaderTwo from "../../components/header/header-two";
import StickyHeader from "../../components/header/sticky-header";
import PageHeader from "../../components/page-header";
import Footer from "../../components/footer";
import LoadingContent from "../../components/loading-content-1";
import ProgramDetails from "../../components/programs/program-details";

var Api_url = process.env.GATSBY_API_URL;
console.log("API_URL=" + Api_url);

const axiosConfig = {
  headers: {
    "Content-Type": "application/json; text/html; charset=UTF-8",
    "Access-Control-Allow-Origin": "*"
  }
};

class NationalProgramDetails extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      id: '',
      data: {},
      LoadingFlag: false,
      DataFlag: false
    };
  }
  getDetails = async () => {
    console.log("getDetails called ");

    var id = this.props.location.state.id
    console.log("id=" + id);

    var url = Api_url + `/api/programs/event-details`;
    console.log("url=" + url);
    var postData = {
      UserInterface: 1,
      EventCode: id,
      OrganizationTypeCode: 1
    };
    this.setState({ LoadingFlag: true });
    console.log({ postData });
    await axios
      .post(url, postData, axiosConfig)
      .then((res) => {
        console.log("RESPONSE RECEIVED: ", res);
        console.log("res=" + JSON.stringify(res));

        this.setState({ LoadingFlag: false });

        var flag = res.data.flag;
        var records = res.data.records;
        console.log({ records });

        this.setState({ DataFlag: flag, data: records });
      })
      .catch((err) => {
        console.log("AXIOS ERROR: ", err);
      });
  };
  componentDidMount() {
    console.log("componentDidMount called ");
    var id = this.props.location.state.id
    this.setState({ id: id });
    console.log("id=" + id);
    this.getDetails();
  }
  render() {
    return (
      <Layout pageTitle="Program Details Page  | JCI India | Be Better">
        <HeaderTwo />
        <StickyHeader />
        <PageHeader title="Program Details" crumbTitle="Program Details" />
        <>
          {this.state.LoadingFlag ? <LoadingContent /> : ''}
          {this.state.DataFlag ? <ProgramDetails data={this.state.data} /> : ''}
        </>
        <Footer />
      </Layout>
    );
  }
}

export default NationalProgramDetails;
